// extracted by mini-css-extract-plugin
export default {"card":"Bin_card__gw+7Y","qrCode":"Bin_qrCode__1UZT-","styleList":"Bin_styleList__8I1yk","styles":"Bin_styles__cAekL"};